avisos.component('avisos.avisosComponent', {
    templateUrl: 'avisos/avisos.html',
    controller: 'avisos.avisosController'
});

avisos.controller('avisos.avisosController', ['$scope', 'coreLanguage', '$state', 'coreFb', '$timeout', '$filter', function($scope, $text, $state, $fb, $timeout, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.filter = {};
    $ctrl.produtoOptions = [];

    const _cleanReg=(reg)=>{
        //delete reg.dataCadastro;
        delete reg.alteracao;
        delete reg.criacao;
        //delete reg.docPath;
        delete reg.produtoNome;
        delete reg.indice;

        return reg;
    }

    const _getDominio=()=>{
        $fb.db.list('cad_produtos', [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}]).then(list=>{
            $ctrl.produtoOptions = list.map((item)=>{ return {id:item.id, nome: item.data.nome, niveis: item.data.niveis }});
            $ctrl.produtoOptions.unshift({id:'all', nome:$text.all, niveis:[$text.all, 'starter', 'pro', 'partner']});

            $ctrl.cfgAvisos.options = $ctrl.produtoOptions;
            _checkNomeProduto();
        });
    };

    const _tableRerender=()=>{
        let config = angular.copy($ctrl.tableObj);
        $ctrl.tableObj = null;
        $timeout(()=>{ $ctrl.tableObj = config; }, 100);
    };

    const _getAvisos=()=>{
        $state.params.showGlobalLoading = true;
        $ctrl.tableObj.data = [];

        $fb.db.list('cad_avisos', [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]},{limit:[500]}]).then(list=>{

            $ctrl.tableObj.data = list.map((item)=>{
                return {
                    ...item.data,
                    dataCadastro: item.data.dataCadastro ? item.data.dataCadastro.toDate() : item.data.criacao.data.toDate(),
                    produtoNome: null,
                    indice: `${item.data.titulo || ''} ${item.data.idProduto || ''}`,
                    docPath: item.path
                }
            });

            _checkNomeProduto();

            $state.params.showGlobalLoading = false;
            _tableRerender();
        });
    };

    const _editRegistroModal=(value)=>{
        $ctrl.cfgAvisos.dados = angular.copy(value);
        $ctrl.cfgAvisos.title = $text.editUser;
        $ctrl.cfgAvisos.show = true;
    };

    const _confirmAvisos=()=>{
        $ctrl.cfgAvisos.isLoading=true;

        if($ctrl.cfgAvisos.dados.docPath){
            $ctrl.cfgAvisos.dados = _cleanReg($ctrl.cfgAvisos.dados);

            $fb.db.update($ctrl.cfgAvisos.dados.docPath, $ctrl.cfgAvisos.dados).then((res)=>{
                $ctrl.cfgAvisos.show = false;
                $ctrl.cfgAvisos.isLoading=false;
                $state.reload();
            });

        }else{
            $fb.db.add('cad_avisos', $ctrl.cfgAvisos.dados).then((res)=>{
                $ctrl.cfgAvisos.show = false;
                $ctrl.cfgAvisos.isLoading=false;
                $state.reload();
            });
        }
    };

    const _deleteAviso=()=>{
        $ctrl.cfgAvisos.isLoading=true;

        if($ctrl.cfgAvisos.dados.docPath){
            $fb.db.del($ctrl.cfgAvisos.dados.docPath).then((res)=>{
                $ctrl.cfgAvisos.show = false;
                $ctrl.cfgAvisos.isLoading=false;

                $state.reload();
            });
        }
    };

    const _duplicateAviso=(registro)=>{

        let obj = _cleanReg(angular.copy(registro));
        delete obj.docPath;

        obj.titulo = `Cópia de ${obj.titulo}`;
        
        $fb.db.add('cad_avisos', obj).then(res=>{
            $state.reload();
        });
    };

    const _checkNomeProduto=()=>{
        
        const __getProdutoNome=(id)=>{
            if($ctrl.produtoOptions && $ctrl.produtoOptions.length){
                return $filter('filter')($ctrl.produtoOptions, {id:id})[0]?.nome || $text.notDefined;
            }
        };

        if(!$ctrl.tableObj.data || !$ctrl.produtoOptions.length){
            return;
        }

        $ctrl.tableObj.data.forEach((item)=>{ item.produtoNome = __getProdutoNome(item.idProduto); });

    };

    $ctrl.addRegistroModal=()=>{
        $ctrl.cfgAvisos.dados = {};
        $ctrl.cfgAvisos.title = $text.addUser;
        $ctrl.cfgAvisos.show = true;
    };

    $ctrl.setTableFilter=(value, field)=>{
        if(field==="search"){
            if(!value.length){
                delete $ctrl.filter.indice;
            }else{
                $ctrl.filter.indice = value;
            }
        }else{
            if(!!value){
                $ctrl.filter[field] = value;
            }else{
                delete $ctrl.filter[field];
            }
        }
    };

    $ctrl.cfgAvisos = {
        show:false,
        dados: {},
        isLoading:false,
        options: $ctrl.produtoOptions,
        confirm: _confirmAvisos,
        delete: _deleteAviso
    };

    $ctrl.tableObj = {
        pageSize: 100,
        pageCount: 1,
        columns:[
            {title: $text.name.toUpperCase(), width:'25%', key:'titulo', type:'text', export:true},
            {title: $text.product.toUpperCase(), key:'produtoNome', type:'text', export:true}
        ],
        data:[],
        actions:{
            enable:{ edit:true, view:true, delete:false, duplicate: true },
            edit: _editRegistroModal,
            view: _editRegistroModal,
            duplicate: _duplicateAviso
        },
        bulkActions:{
            enable: {delete:false},
            custom:[]
        }

    };

    $ctrl.$onInit = () => {
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;

        _getDominio();
        _getAvisos();
    };
    
}]);